import * as React from 'react';
import { ILocation } from '../../store/pik_data/location';
const styles = require('./cities.css');
import { Region } from '../../utils/regions';
import { PikLink } from '../pik_link/pik_link';
import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';

interface IStoreProps {
  locations: ILocation[];
  currentRegion: Region;
}

type IProps = IStoreProps;

class CitiesPure extends React.PureComponent<IProps, object> {
  public render() {
    const { locations, currentRegion } = this.props;

    return (
      <ul className={styles['list']}>
        {locations.map(location => (
          <li key={location.linkId} className={styles['list-item']}>
            <PikLink
              to={{ query: { location: location.linkId.toString() } }}
              pikStyles={[styles['link'], currentRegion === location.linkId && styles['active']]}
              mergeQuery
            >
              {location.name}
            </PikLink>
            <span className={styles['counter']}>{location.jkCount}</span>
          </li>
        ))}
      </ul>
    );
  }
}

export const Cities = connect((state: IApplicationState) => ({
  currentRegion: state.filter.query.region,
  locations: state.locations.filter(location => location.jkCount > 0) || [],
}))(CitiesPure);
